import { useMutation } from "@tanstack/react-query";
import verificationService from "..";

function useCheckNationalIDImage() {
  return useMutation({
    mutationFn: verificationService.updateNationalIDImage,
  });
}

export default useCheckNationalIDImage;
